module.exports = __webpack_public_path__ + "static/img/电子处方@2x1.3ae2642e.png";